/**
 * trạng thái hồ sơ khi EnrollmentStatus = 4
 * Trạng thái nhập học
 * */
export default {
  Elect: 1, // trúng tuyển
  NotElect: 2, // không trúng tuyển
  Admission: 3, // đã nhập học
  ArrangeClass: 4, // đã xếp lớp
}
